export const FEEDBACK_FIELD_LIMITS = {
  descriptionMin: 1,
  descriptionMax: 2000,
} as const;

export const FEEDBACK_IMAGE_LIMITS = {
  maxCount: 3,
  maxSizeBytes: 5 * 1024 * 1024,
  maxSizeMB: 5,
  allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
} as const;
